module.exports = __webpack_public_path__ + "static/img/jishu.49f1b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/jishu.png
// module id = jLC/
// module chunks = 1